import { useMemo } from 'react';

import { useSelector } from 'react-redux';

import { selectAccountSlug } from '@/redux/session/selectors';

import { useDialogsList } from './useDialogsList';
import { useLeaveModal } from './useLeaveModal';
import { selectBrainId } from '../redux/selectors';

type ConditionLink = { name: string; to: string | null; goTo: (() => void) | null };

export const useConditionLink = (conditionId?: string): ConditionLink | null => {
  const leaveModal = useLeaveModal();
  const slug = useSelector(selectAccountSlug);
  const brainId = useSelector(selectBrainId);
  const dialogs = useDialogsList();

  const condition = useMemo(() => {
    if (!conditionId || !dialogs) {
      return null;
    }
    for (const dialog of dialogs) {
      const nodes = Array.isArray(dialog.nodes) ? dialog.nodes : [];
      for (const node of nodes) {
        const index = node.conditions?.findIndex((item) => item.condition_id === conditionId) ?? -1;
        if (index >= 0) {
          return {
            name: node.conditions?.[index]?.name ?? '',
            nodeId: node.node_id,
            dialogId: dialog.dialog_id,
            index,
          };
        }
      }
    }
    return null;
  }, [dialogs, conditionId]);

  if (!condition) {
    return null;
  }

  const params = new URLSearchParams({
    node: condition.nodeId,
    condition: String(condition.index),
  });
  const to =
    slug && brainId
      ? `/${slug}/ai-agents/${brainId}/workflows/dialogs/${condition.dialogId}?${params}`
      : null;

  return { name: condition.name, to, goTo: to ? () => leaveModal(to) : null };
};
